import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { contentSpacingStyles, titleSpacingStyles } from "@tCentro/theme/mixins";
import breakpointValuesMediaQueries from "@tCentro/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export default {
    
    body: {
        fontFamily: TYPOGRAPHY.fontFamily.base,
        lineHeight: TYPOGRAPHY.lineHeight.base,
        size: TYPOGRAPHY.size.base,
        weight: TYPOGRAPHY.weight.base,
    },
    legend: {
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        transform: "uppercase",
        css: css`
            line-height: 16px;
        `,
    },
    p: {
        size: TYPOGRAPHY.size.large,
        weight: TYPOGRAPHY.weight.base,
        css: css`
            ${contentSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [16, 18, null, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h1: {
        size: 56,
        weight: TYPOGRAPHY.weight.black,
        color: COLORS.black,
        css: css`
            line-height: 64px;
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [32, 56, null, null, null], properties: ["font-size"], unit: "px" },
                    { values: [700, 800, null, null, null], properties: ["font-weight"] },
                    { values: [40, 64, null, null, null], properties: ["line-height"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h2: {
        size: 40,
        weight: TYPOGRAPHY.weight.black,
        color: COLORS.black,
        css: css`
            line-height: 48px;
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [22, 40, null, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h3: {
        size: 32,
        weight: TYPOGRAPHY.weight.bold,
        color: COLORS.black,
        css: css`
            line-height: 40px;
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [24, 32, null, null, null], properties: ["font-size"], unit: "px" },
                    { values: [600, 700, null, null, null], properties: ["font-weight"] },
                    { values: [32, 40, null, null, null], properties: ["line-height"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h4: {
        size: 24,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        css: css`
            line-height: 32px;
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [14, 24, null, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h5: {
        size: 18,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        css: css`
            line-height: 24px;
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [12, 18, null, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    h6: {
        size: 16,
        weight: TYPOGRAPHY.weight.mediumbold,
        color: COLORS.black,
        css: css`
            line-height: 24px;
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [12, 16, null, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerPrimary: {
        transform: "none",
        size: 29,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, 31, 37, null, 70], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerSecondary: {
        transform: "none",
        size: 22,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, null, null], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    headerTertiary: {
        transform: "none",
        size: 20,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: 1.2,
        css: css`
            ${titleSpacingStyles()}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, null, null, 30], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
};
